import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './state/index';
import axios from 'axios';
import moment from 'moment';
import Notifications from 'vue-notification';
import API from './API';
import VueMask from 'v-mask';
import './validations';
import customerly from './customerly';

// Add a request interceptor
axios.interceptors.request.use(function(request) {
  // Show a loader notification.
  SDV.$notify({
    group: 'loading',
    title: 'Loading...',
    text: 'Please wait while your request is being processed.',
    classes: 'is-info',
    duration: -1,
    closeOnClick: false,
    ignoreDuplicates: true,
    speed: 0
  });
  return request;
});

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    SDV.$notify({
      group: 'loading',
      clean: true
    });
    return response;
  },
  function(error) {
    SDV.$notify({
      group: 'loading',
      clean: true
    });
    let user = undefined;
    // Only do the automatic handling if we're not on the signin path.
    if (error.config.url !== API.signIn) {
      switch (error.response.status) {
        case 401: // Unauthorized
          router.push({
            path: '/',
            query: {
              from: window.location.pathname
            }
          });
          break;
        case 402: // Payment Required
          user = store.getters['auth/getUser'];
          user.account.delinquent = true;
          store.commit('auth/setUser', user);
          router.push({
            path: '/profile/payment',
            query: {
              from: window.location.pathname,
              delinquent: true
            }
          });
          break;
      }
    }
    return Promise.reject(error);
  }
);

// Global properties on Vue object
// moment
Object.defineProperty(Vue.prototype, '$moment', {
  value: moment
});
// email validation pattern
Object.defineProperty(Vue.prototype, '$emailPattern', {
  // eslint-disable-next-line no-useless-escape
  value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
});
// axios
Object.defineProperty(Vue.prototype, '$axios', {
  value: axios
});
// API endpoints
Object.defineProperty(Vue.prototype, '$API', {
  value: API
});

Object.defineProperty(Vue.prototype, '$customerly', {
  value: customerly
});

Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(VueMask);
// -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// Allow `<zapier-app-directory>` custom element
// -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
Vue.config.ignoredElements = ['zapier-app-directory'];

const SDV = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
